import React, { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  { question: "What is loan against mutual funds?", answer: "A loan against mutual funds lets you borrow money by pledging your mutual fund units as collateral." },
  { question: "What are the benefits?", answer: "You get instant liquidity, lower interest rates, and retain mutual fund ownership." },
  { question: "What is the eligibility criteria?", answer: "The criteria include KYC compliance and having eligible mutual funds in demat or statement form." },
  { question: "How do I apply?", answer: "You can apply online by logging into your account and following the loan application steps." },
  { question: "Are my mutual funds safe?", answer: "Yes, the funds remain in your account but are lien-marked for the lender until repayment." },
  { question: "How is my credit limit calculated?", answer: "Based on the value and type of your mutual fund holdings." },
];

interface AccordionItemProps {
  item: FAQItem;
  onPress: () => void;
  expanded: boolean;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ item, onPress, expanded }) => {
  return (
    <div style={{ borderBottom: "1px solid #F3F5F7" }}>
      <button
        onClick={onPress}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "18px",
          paddingBottom: "18px",
          background: "none",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
          fontFamily: "DM Sans, sans-serif",
        }}
      >
        <span style={{ color: "#222", fontWeight: "400", fontSize: "16px", lineHeight: "20px", flex: 1, paddingRight: "10px" }}>
          {item.question}
        </span>
        <div
          style={{
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transition: "transform 300ms cubic-bezier(0.4, 0, 0.2, 1)",
            transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
          }}
        >
          {/* Caret — right chevron matching Android */}
          <div
            style={{
              width: "10px",
              height: "10px",
              borderTop: "2px solid #222",
              borderRight: "2px solid #222",
              transform: "rotate(45deg)",
            }}
          />
        </div>
      </button>

      <div
        style={{
          overflow: "hidden",
          maxHeight: expanded ? "500px" : "0px",
          opacity: expanded ? 1 : 0,
          transition: "max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 300ms cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <div style={{ paddingLeft: "16px", paddingRight: "16px", paddingBottom: "15px", paddingTop: "10px" }}>
          <p style={{ color: "#636363", fontSize: "15px", lineHeight: "22px", fontWeight: "400", margin: 0, fontFamily: "DM Sans, sans-serif" }}>
            {item.answer}
          </p>
        </div>
      </div>
    </div>
  );
};

const FAQAccordion: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [viewAll, setViewAll] = useState<boolean>(false);

  const toggleItem = (index: number) => {
    if (viewAll) setViewAll(false);
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleViewAll = () => {
    setViewAll(!viewAll);
    setExpandedIndex(null);
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingTop: "16px", fontFamily: "DM Sans, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingLeft: "16px", paddingRight: "16px", paddingBottom: "4px" }}>
        <h3 style={{ fontSize: "22px", fontWeight: "700", color: "#222", margin: 0, lineHeight: "28px" }}>FAQs</h3>
        <button
          onClick={handleViewAll}
          style={{
            color: "#63BC7D",
            fontWeight: "500",
            fontSize: "16px",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontFamily: "DM Sans, sans-serif",
          }}
        >
          {viewAll ? "Collapse all" : "View all"}
        </button>
      </div>
      {faqData.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          expanded={viewAll || expandedIndex === index}
          onPress={() => toggleItem(index)}
        />
      ))}
    </div>
  );
};

export default FAQAccordion;
